var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.stream!==null)?_c('wss-player',{staticStyle:{"background":"#000","height":"100%"},attrs:{"stream":_vm.stream},on:{"reconnect":_vm.reconnect,"capture-picture":_vm.capturePicture}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7edc72bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/player/DevicePlayer.vue
// module id = null
// module chunks = 